var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.044 9.96875C19.3089 10.5312 18.3821 11.2188 15.1222 13.5312C14.483 14 13.3004 15.0312 12.1818 15.0312C11.0312 15.0312 9.88068 14 9.20952 13.5312C5.94957 11.2188 5.02273 10.5312 4.28764 9.96875C4.1598 9.875 4 9.96875 4 10.125V16.5C4 17.3438 4.67116 18 5.53409 18H18.8295C19.6605 18 20.3636 17.3438 20.3636 16.5V10.125C20.3636 9.96875 20.1719 9.875 20.044 9.96875ZM12.1818 14C12.9169 14.0312 13.9716 13.0938 14.5149 12.7188C18.7656 9.71875 19.0852 9.4375 20.044 8.6875C20.2358 8.5625 20.3636 8.34375 20.3636 8.09375V7.5C20.3636 6.6875 19.6605 6 18.8295 6H5.53409C4.67116 6 4 6.6875 4 7.5V8.09375C4 8.34375 4.09588 8.5625 4.28764 8.6875C5.24645 9.4375 5.56605 9.71875 9.81676 12.7188C10.3601 13.0938 11.4148 14.0312 12.1818 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.d2e02b29ae6a38a167f8d3dfdbb02152.svg";
export { ForwardRef as ReactComponent };